<template>
  <div class="listview">
    <table>
      <thead class="none">
        <tr>
          <td class="listview__title items">LOCATION</td>
          <td class="listview__title placement">PLACEMENT</td>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in items" :key="index" class="content">
          <td class="items">
            <span class="subhead">
              {{item.location_name}}
            </span>
          </td>
          <td class="placement">
            <span class="subhead">
              {{item.placement}}, {{item.city_name}}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="listview__showmore">
      <slot name="infiniteLoading"/>
    </div>
    <div class="emptyState">
      <adx-empty-selection v-if="isEmpty && !loading" />
    </div>
    <div class="listview__loadingWrapper">
      <slot name="loading" />
    </div>
  </div>
</template>

<script>
import MenuExpansion from '@/components/MenuExpansion'
import Alert from '@/components/Alert'
import LoadingSecondary from '@/components/Loading/Secondary'
import EmptySelection from '@/components/NotFound/Selection'
import Tooltip from '@/components/Tooltip'

import { mapGetters, mapActions, mapMutations } from 'vuex'
import api from '@/api'
import { apiV2 } from '@/api/urls'

export default {
  name: 'adx-host-campaign-detail-list',
  components: {
    'menu-expansion': MenuExpansion,
    'adx-alert': Alert,
    'adx-loading-secondary': LoadingSecondary,
    'adx-empty-selection': EmptySelection,
    "adx-tooltip": Tooltip
  },
  props: {
    items: {
      required: false
    },
    headers: {
      required: false
    },
    category: {
      required: false
    },
    menuList: {
      required: false
    },
    page: {
      required: false
    },
    isAction: {
      required: false
    },
    loading: {
      required: false
    }
  },
  data() {
    return {
      isEmpty: false,
    }
  },
  updated() {
    if(this.items == 0) {
      this.isEmpty = true
    }else {
      this.isEmpty = false
    }
  },
  methods: {
    
  },
  computed: {
    
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>